<ng-template [ngIf]="isDesktop()" [ngIfElse]="mobile">
    <div class='row dropdown-nav-bar'>
        <!-- Módulos -->
        <div class='col-3'>
            <!-- Search -->
            <!-- <div class="input-group input-group-sm">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                </div>
                <input class="form-control form-control-sm" type="text" placeholder="Buscar..." (input)="filter($event.target.value)" (click)="$event.stopPropagation();">
            </div> -->
            <br>
            <div class='module-card card' *ngFor="let item of filteredModules" (mouseenter)="changeMenus(item)" [routerLink]="getModuleFirstRoute(item)">
                <div class="card-header card-header-module card-header-icon">
                    <div class="card-icon-m" [ngStyle]="{'background-color': item.color}">
                        <i [ngClass]="item.icon"></i>
                    </div>
                    <div class='ml-2 d-inline-block'>
                        <div class='menu-title'><h4>{{item.servicio}}</h4></div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Menús -->
        <div class='col-9 text-center'>
            <div class="row">
                <div class="col-xl-4 col-md-6 px-2" *ngFor="let item of filteresMenus; let j = index">
                    <div class='menu-card card' [placement]="'bottom'" ngbTooltip="{{item.descripcion}}">
                        <div class="card-header card-header-icon">

                            <div class='d-flex justify-content-start' style="transform: translateY(6px);">
                                <div class="card-icon-m d-block mr-3" [ngStyle]="{'background-color': item.color}">
                                    <i [ngClass]="item.icon"></i>
                                </div>
                                <div class='d-block menu-title-container'>
                                    <h4 class='menu-title'><a [routerLink]="getMenuFirstRoute(item)">{{item.nombre}}</a></h4>
                                </div>
                            </div>

                            <div style="border-top: 1px solid rgba(0, 0, 0, 0.3);">
                                <ul style="list-style-type: disc; font-size: 12px; text-align: left; padding-left: 16px;">
                                    <ng-container *ngFor="let submenu of item.sub_menu; let i = index">
                                        <li *ngIf="i < MAX_SUBMENU">
                                            <span class='submenu' [routerLink]="submenu.url" [queryParams]="submenu.queryParams" (click)="auditoria(submenu.url)">{{submenu.title}}</span>
                                        </li>
                                        <li *ngIf="i == MAX_SUBMENU">
                                            <span class='submenu' [routerLink]="item.url" [queryParams]="submenu.queryParams">Ver más...</span>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mobile>
    <div class='dropdown-nav-bar' [ngClass]="mobileWidth === '100vw' ? 'dropdown-nav-bar-mobile-full-width' : 'dropdown-nav-bar-mobile-80-width'">
        <!-- Search -->
        <div class="input-group input-group-sm">
            <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input class="form-control form-control-sm" type="text" placeholder="Buscar..." (input)="filter($event.target.value)" (click)="$event.stopPropagation();">
        </div>
        <!-- Módulos Menú -->
        <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item" *ngFor="let mod of filteredModules">
                <a class="nav-link" data-toggle="collapse" [href]="'div#' + mod.servicio" role="button" aria-expanded="false">
                    <div class='d-inline-block w-100'>
                        <div class='table-header'>
                            <div>
                                <div class='block-icon d-inline-block' [style]="{'background-color': mod.color || '#808080'}">
                                    <i [ngClass]="mod.icon"></i>
                                </div>
                                <div class='block-text d-inline-block'>
                                    <span>{{mod.servicio}}</span>
                                </div>
                            </div>
                            <div class='block-down d-inline-block'>
                                <i class='fas fa-chevron-down'></i>
                            </div>
                        </div>
                    </div>
                </a>
                <div class="collapse" [id]="mod.servicio">
                    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                        <li class="nav-item" *ngFor="let menu of mod.menu">
                            <a class="menu-block-icon nav-link" data-toggle="collapse" [href]="'div#' + menu.id" role="button" aria-expanded="false">
                                <div class='d-inline-block w-100'>
                                    <div class='table-header'>
                                        <div>
                                            <div class='block-icon d-inline-block' [style]="{'background-color': menu.color || '#808080'}">
                                                <i [ngClass]="menu.icon"></i>
                                            </div>
                                            <div class='block-text d-inline-block'>
                                                <span>{{menu.nombre}}</span>
                                            </div>
                                        </div>
                                        <div class='block-down d-inline-block'>
                                            <i class='fas fa-chevron-down'></i>
                                        </div>
                                    </div>
                                </div>
                            </a>
                            <div class="collapse" [id]="menu.id">
                                <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                                    <li class="nav-item" *ngFor="let submenu of menu.sub_menu">
                                        <a class="submenu-block-icon nav-link" [routerLink]="submenu.url" [queryParams]="submenu.queryParams" (click)="collapseMenu()">
                                            <div class='block-text d-inline-block'>
                                                {{submenu.title}}
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</ng-template>

